import { useEffect, useState } from "react";
import { ListBox } from "primereact/listbox";
import { Button } from "primereact/button";

export default function ReportRightPanel({
    groupByOptions,
    groupBySelected,
    setGroupBySelected
}) {
    return (
        <div className="report-right">
            <PivotBlock
                title="Group By This Columns"
                options={groupByOptions}
                selected={groupBySelected}
                setSelected={setGroupBySelected}
            />
        </div>
    );
}

function PivotBlock({ title, options = [], selected = [], setSelected }) {
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    const [leftSel, setLeftSel] = useState(null);
    const [rightSel, setRightSel] = useState(null);

    // ✅ INITIALIZE ONLY WHEN DATA CHANGES (NOT EVERY CLICK)
    useEffect(() => {
        const selectedValues = (selected || []).map(s => s.value);

        const leftData = (options || []).filter(
            opt => !selectedValues.includes(opt.value)
        );

        setLeft(leftData);
        setRight(selected || []);
    }, [options, selected]);

    // 👉 MOVE ONE → RIGHT (TRANSFER)
    const moveRight = () => {
        if (!leftSel) return;

        const item = left.find(i => i.value === leftSel);
        if (!item) return;

        const newLeft = left.filter(i => i.value !== leftSel);
        const newRight = [...right, item];

        setLeft(newLeft);
        setRight(newRight);
        setSelected(newRight);

        setLeftSel(null);
    };

    // 👉 MOVE ONE → LEFT (TRANSFER BACK)
    const moveLeft = () => {
        if (!rightSel) return;

        const item = right.find(i => i.value === rightSel);
        if (!item) return;

        const newRight = right.filter(i => i.value !== rightSel);
        const newLeft = [...left, item];

        setRight(newRight);
        setLeft(newLeft);
        setSelected(newRight);

        setRightSel(null);
    };

    // 👉 MOVE ALL → RIGHT (TRANSFER ALL)
    const moveAllRight = () => {
        if (!left.length) return;

        const newRight = [...right, ...left];

        setRight(newRight);
        setLeft([]); // ✅ REMOVE FROM LEFT
        setSelected(newRight);
    };

    // 👉 MOVE ALL → LEFT (TRANSFER BACK)
    const moveAllLeft = () => {
        if (!right.length) return;

        const newLeft = [...left, ...right];

        setLeft(newLeft);
        setRight([]); // ✅ REMOVE FROM RIGHT
        setSelected([]);
    };

    // 👉 MOVE UP
    const moveUp = () => {
        if (rightSel) {
            const index = right.findIndex(i => i.value === rightSel);
            if (index <= 0) return;

            const arr = [...right];
            [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];

            setRight(arr);
            setSelected(arr);
            setRightSel(arr[index - 1].value);
            return;
        }

        if (leftSel) {
            const index = left.findIndex(i => i.value === leftSel);
            if (index <= 0) return;

            const arr = [...left];
            [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];

            setLeft(arr);
            setLeftSel(arr[index - 1].value);
        }
    };

    // 👉 MOVE DOWN
    const moveDown = () => {
        if (rightSel) {
            const index = right.findIndex(i => i.value === rightSel);
            if (index === right.length - 1) return;

            const arr = [...right];
            [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];

            setRight(arr);
            setSelected(arr);
            setRightSel(arr[index + 1].value);
            return;
        }

        if (leftSel) {
            const index = left.findIndex(i => i.value === leftSel);
            if (index === left.length - 1) return;

            const arr = [...left];
            [arr[index + 1], arr[index]] = [arr[index], arr[index + 1]];

            setLeft(arr);
            setLeftSel(arr[index + 1].value);
        }
    };

    return (
        <div className="pivot-block">
            <div className="pivot-title">{title}</div>

            <div className="pivot-grid">

                <ListBox
                    value={leftSel}
                    options={left}
                    optionLabel="label"
                    optionValue="value"
                    dataKey="value"
                    onChange={(e) => setLeftSel(e.value)}
                    className="pivot-list"
                />

                <div className="pivot-actions">
                    <Button icon="pi pi-angle-right" onClick={moveRight} disabled={!leftSel} className="pivot-btn" />
                    <Button icon="pi pi-angle-left" onClick={moveLeft} disabled={!rightSel} className="pivot-btn" />
                    <Button icon="pi pi-angle-up" onClick={moveUp} disabled={!leftSel && !rightSel} className="pivot-btn" />
                    <Button icon="pi pi-angle-down" onClick={moveDown} disabled={!leftSel && !rightSel} className="pivot-btn" />
                    <Button icon="pi pi-angle-double-right" onClick={moveAllRight} disabled={!left.length} className="pivot-btn" />
                    <Button icon="pi pi-angle-double-left" onClick={moveAllLeft} disabled={!right.length} className="pivot-btn" />
                </div>

                <ListBox
                    value={rightSel}
                    options={right}
                    optionLabel="label"
                    optionValue="value"
                    dataKey="value"
                    onChange={(e) => setRightSel(e.value)}
                    className="pivot-list"
                />
            </div>
        </div>
    );
}